import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classnames from 'classnames';
import React__default from 'react';

var _excluded = ["as", "aria-label", "data-testid", "content", "children", "className", "color", "location"];
var Badge = function Badge(_ref) {
  var _ref$as = _ref.as,
    As = _ref$as === void 0 ? 'span' : _ref$as,
    ariaLabel = _ref['aria-label'],
    dataTestId = _ref['data-testid'],
    content = _ref.content,
    children = _ref.children,
    className = _ref.className,
    color = _ref.color,
    _ref$location = _ref.location,
    location = _ref$location === void 0 ? 'top-right' : _ref$location,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var finalClasses = classnames('C-Badge', _defineProperty(_defineProperty({}, "--location-".concat(location), "".concat(location)), "--color-".concat(color), color), className);
  if (content && !ariaLabel) {
    console.error("Hey Canvas User! Your badge needs an aria-label to tell screen readers what it represents.");
  }
  if (!content || location === 'none') {
    return children;
  }
  return /*#__PURE__*/React__default.createElement(As, _extends({
    className: finalClasses,
    "data-badge": content,
    role: "alert",
    "aria-live": "polite",
    "aria-label": ariaLabel,
    "data-testid": dataTestId
  }, otherProps), children);
};
Badge.displayName = 'Badge';

export { Badge as default };
